import axios from "axios";
import {
  IAdditional,
  IExample,
  IHowWork, IPriceMultiply,
  IProcessing,
  IService, ISetting,
  IType,
} from "../types";
import * as qs from "qs";
const auth = `bearer ${process.env.REACT_APP_AUTH_KEY}`;
const axiosDataLoader = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API + "/api/",
  method: "GET",
  headers: {
    Authorization: auth,
  },
});
const instance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API + "/api/",
  headers: {
    "Content-Type": "application/json",
    Authorization: auth,
  },
});
const instanceFD = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API + "/api/",
  method: "POST",
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: auth,
  },
});

export const APIReq = {
  async mail(data: FormData) {
    return await instanceFD.post("calc-requests", data);
  },
  async call(data: { phone: string }) {
    return await instance.post("call-requests", { data });
  },
  async chat(data: { phone: string; email: string; question: string }) {
    return await instance.post("chat-requests", { data });
  },
};

const cache: Map<string, string> = new Map();

const sessionCache = {
  /**
   * Сохранение данных в localStorage на основе ключа и текущего solId
   * @param key ключ
   * @param value данные
   */
  saveParam(key: string, value: string) {
    // sessionStorage.setItem(key, JSON.stringify(value))
    cache.set(key, JSON.stringify(value));
  },
  /**
   * Получение данных из localStorage по ключу и текущему solId
   * @param key ключ
   * @return значение по ключу
   */
  loadParam(key: string): any[] {
    try {
      // return JSON.parse(sessionStorage.getItem(key))
      return JSON.parse(cache.get(key));
    } catch (e) {
      return [];
    }
  },
};

export const ApiData = {
  async get(url: string, query?: string) {
    try {
      const reqUrl = url + (query ? `?${query}` : "");
      const data = sessionCache.loadParam(url);
      if (data?.length) return data;
      const res = await axiosDataLoader.get(reqUrl);
      if (res.status === 200) {
        const data = res.data?.data;
        sessionCache.saveParam(url, data);
        return data;
      } else return [];
    } catch (e) {
      console.log(e);
      return [];
    }
  },
  async examples(): Promise<IExample[]> {
    return await this.get("examples", "populate=media");
  },
  async services(): Promise<IService[]> {
    return await this.get("services", "populate=image");
  },
  async howWorks(): Promise<IHowWork[]> {
    return await this.get("how-works");
  },
  async settings(): Promise<ISetting> {
    return await this.get("setting","populate=*");
  },
  async multiply(): Promise<IPriceMultiply[]> {
    return await this.get("price-multiplies","populate=*");
  },
  async calc(): Promise<IType[]> {
    const asserts = qs.stringify({
      populate: {
        views: {
          populate: {
            prices: { populate: "depth" },
            photo: "*",
          },
        },
        photo: { populate: "*" },
      },
    });
    return await this.get("types", `${asserts}`);
  },
  async processing(): Promise<IProcessing[]> {
    const asserts = qs.stringify({
      populate: {
        processing_depths: {
          populate: {
            processing_prices: "*",
            photo: "*",
          },
        },
        formats: { populate: "*" },
        photo: { populate: "*" },
      },
    });
    return await this.get("processings", `${asserts}`);
  },
  async additionally(): Promise<IAdditional[]> {
    const asserts = qs.stringify({
      populate: {
        additional_choises: {
          populate: {
            additional_prices: "*",
            views: "*",
          },
        },
        photo: { populate: "*" },
        formats: { populate: "*" },
        types: { populate: "*" },
      },
    });
    return await this.get("additionals", `${asserts}`);
  },
};
